import React from 'react'
import css from './Card.module.css'
import { Typography } from '../Typography/Typography'

export interface CardProps {
  title?: string
  children?: React.ReactNode
  isHover?: boolean
  onClick?: () => void
}

const Card: React.FC<CardProps> = ({ title, children, isHover = false, onClick }) => {
  return (
    <div
      className={isHover ? `${css.card} ${css.hover}` : css.card}
      onClick={isHover ? onClick : undefined}
      style={isHover ? { cursor: 'pointer' } : {}}
    >
      {title 
      && <Typography variant='h5'>{title}</Typography>}
        <div className={css.content}>
          {children}
        </div>        
    </div>
  )
}

export default Card